import type { GetMyCampaignStatusesResponse } from "schema/gen/es/chiikipoint/wallet/v2/service_pb";
import type { R8CampaignConfig } from "../../../config";
import type { CurrentTime } from "../../../libs/date";
import type { R8CampaignBannerType } from "./r8-campaign-banner";

export function getR8MiyagiBousaiWelcomeCampaignBannerType(
  campaignStatuses: GetMyCampaignStatusesResponse | null,
  currentTime: CurrentTime,
  isTargetResident: boolean,
  config: R8CampaignConfig,
): R8CampaignBannerType {
  if (currentTime.source === "client") {
    return "hidden";
  }

  if (
    currentTime.date < config.startDate ||
    currentTime.date > config.endDate
  ) {
    return "hidden";
  }

  if (!isTargetResident) {
    return "hidden";
  }

  if (!campaignStatuses) {
    return "hidden";
  }

  const { r6Primary, r6Additional, r7OnSignup, r8OnSignup } = campaignStatuses;

  // 新規登録ポイントは年度をまたいで一度だけのため、過去に応募済みなら対象外
  if (
    r6Primary?.isApplied ||
    r6Additional?.isApplied ||
    r7OnSignup?.isApplied
  ) {
    return "received";
  }

  if (r8OnSignup?.isApplied) {
    return "applied";
  }

  if (r8OnSignup?.isWinLimitReached) {
    return "campaign-ended";
  }

  return "not-applied";
}
